import sdk from'js-conflux-sdk/src/index.js';export const conflux=sdk;